import { type ExternalListsClientInterface } from './externalListsClient.types';
import CorporateExternalListsClient from './corporateExternalListsClient';
import GroupExternalListsClient from './groupExternalListsClient';
import OrgUnitExternalListsClient from './orgUnitExternalListsClient';
import type { ClientContext } from '~/services/contextClient';

export default class ExternalListsClientFactory {
    static createClient(context: ClientContext): ExternalListsClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateExternalListsClient(context.teamId);
        } else if (context.orgUnitId) {
            return new OrgUnitExternalListsClient(context.teamId, context.orgUnitId);
        } else if (context.groupId) {
            return new GroupExternalListsClient(context.teamId, context.groupId);
        }

        throw new Error('Invalid context');
    }
}
